import {Licensee, LicenseeType, LicenseType} from "../../schema";

/**
 * Contains methods for generating PlayFramework links
 */
export default class OldUrls {
  static event(id: number | string): string {
    return `/event/${id}`;
  }

  static editLicense(id: string): string {
    return `/brand/license/${id}/edit`;
  }

  static brandInvoices(type: string): string {
    return `/brand/invoices?type=${type}`;
  }

  static eventAttendees(eventId: string): string {
    return `/event/${eventId}#/page/event/${eventId}/attendees`;
  }

  static editContact(contactId: string, encodedUrl: string): string {
    return `/contacts/${contactId}/edit/ref/${encodeURIComponent(encodedUrl)}`;
  }

  static addLicense(licenseeId: string): string {
    return `/brand/license/${licenseeId}/new`;
  }
  static editTrainer(trainerId: string): string {
    return `/trainer/${trainerId}/edit`;
  }

  static editCompany(companyId: string): string {
    return `/company/${companyId}/edit`;
  }

  static editAttendee(eventId: number, attendeeId: number, ref: string | null): string {
    return `/event/${eventId}/attendee/${attendeeId}/edit${ref ? `?ref=${ref}` : ''}`;
  }

  static trainer(trainerId: number): string {
    return `/trainer/${trainerId}/details`;
  }

  static licenseeUrl(licensee: Licensee): string {
    if (licensee.type === LicenseeType.Trainer) {
      return `/trainer/${licensee.id}/details`;
    } else {
      return `/company/${licensee.id}/details`;
    }
  }

  static updateEvaluationImage(eventId: string, attendeeId: string, evaluationId: number): string {
    return `/public/evaluation/${eventId}/${attendeeId}/${evaluationId}`;
  }

  static evaluationShare(eventId: string, attendeeId: string): string {
    return `/public/evaluation/${eventId}/${attendeeId}/share`;
  }

  static startSession(id: string, backToDashboard: boolean): string {
    return `/event/${id}/invoice/pay?backToDashboard=${backToDashboard}`;
  }

  static settings(): string {
    return '/redirect/settings';
  }

  static licenseTypes(): string {
    return '/redirect/license-types';
  }

  static eventTypes(): string {
    return '/redirect/event-types';
  }

  static evaluationFormConfigurations(): string {
    return '/redirect/evaluation-form';
  }

  static listOfCategories(): string {
    return '/trainer/settings#categories';
  }

  static registrationFormConfigurations(): string {
    return '/redirect/registration-form';
  }

  static switchAccount(id: number): string {
    return `/account/switch/${id}`;
  }
}
